var prefix = "_conplus_sh_";
export var b2cAccessToken = prefix + "b2cAccessToken";
export var b2cRefreshToken = prefix + "b2cRefreshToken";
export var internalAccessToken = prefix + "internalAccessToken";
export var internalRefreshToken = prefix + "internalRefreshToken";
export var legacyUserId = prefix + "legacyUserId";
export var userId = prefix + "userId";
export var dateOfBirth = prefix + "dateOfBirth";
export var loginName = prefix + "loginName";
export var userRoles = prefix + "userRoles";
export var authenticationType = prefix + "authenticationType";
export var isFetchingStorage = prefix + "isFetching";
export var name = prefix + "name";
export var surname = prefix + "surname";
export var sidebarCollapsed = prefix + "sidebarCollapsed";
